// extracted by mini-css-extract-plugin
module.exports = {"bannerComponent":"Va","red":"Wa","calloutlink":"Xa","headerTopBanner":"Ya","bgcolorRed":"Za","headerTopCallout":"_a","searchBanner":"ab","hideMobile":"bb"};